import { BaseElement } from "./base-element.js";
import offerBoxStyles from "./offer-box-styles.js";
import { OfferPaymentMixin } from "./mixin/offer-payment-mixin.js";
import { ProductController } from "./product-display-controller.js";
import { quoteContext } from "./quote-context.js";
import { SelectedState } from "./selected-state.js";
import { provide } from "@lit/context";
import { css } from "lit";
import { property, state } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const _PackageToggleOfferElement = class _PackageToggleOfferElement extends OfferPaymentMixin(BaseElement) {
  constructor() {
    super();
    this.quotes = [];
    this.productController = new ProductController(this, () => {
      var _a, _b, _c, _d, _e;
      this.quoteForProductDisplay = (_a = this.productController) == null ? void 0 : _a.value;
      if ((_c = (_b = this.productController) == null ? void 0 : _b.value) == null ? void 0 : _c.offer_id) {
        this.offerId = (_e = (_d = this.productController) == null ? void 0 : _d.value) == null ? void 0 : _e.offer_id;
      }
    });
  }
  /**
   * @ignore
   */
  get offerId() {
    var _a;
    const offerId = (_a = document.cookie.split("; ").find((row) => row.split("=")[0] === this.offerIdCookieName)) == null ? void 0 : _a.split("=")[1];
    return offerId;
  }
  /**
   * @ignore
   */
  set offerId(offerId) {
    document.cookie = `${this.offerIdCookieName}=${offerId};max-age=604800;`;
  }
  /**
   * @ignore
   */
  get offerIdCookieName() {
    return "vertical_insure_offer_id:" + this.product;
  }
  offerStateChangeHandler(e) {
    var _a, _b, _c;
    this.errors = [];
    const targetItem = e.target;
    let offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");
    if ([...offers].some((el) => el.quote == void 0)) {
      return;
    }
    offers == null ? void 0 : offers.forEach((c) => {
      const item = c;
      if (item.dataset.uniqueId != targetItem.dataset.uniqueId) {
        item.selectedState = SelectedState.UNKNOWN;
      }
    });
    offers = (_b = this.shadowRoot) == null ? void 0 : _b.querySelectorAll("#offers *");
    if ([...offers].some((el) => el.selectedState == SelectedState.ACCEPTED)) {
      this.selectedState = SelectedState.ACCEPTED;
    }
    offers = (_c = this.shadowRoot) == null ? void 0 : _c.querySelectorAll("#offers *");
    if ([...offers].every((el) => el.selectedState == SelectedState.UNKNOWN)) {
      this.selectedState = SelectedState.UNKNOWN;
    }
    const currentQuotes = [];
    const options = {
      detail: [...offers].map((o) => {
        const el = o;
        currentQuotes.push(el.quote);
        return {
          quote: el.quote,
          selectedState: SelectedState[el.selectedState]
        };
      }),
      bubbles: true,
      composed: true
    };
    this.quotes = currentQuotes;
    this.dispatchEvent(new CustomEvent("offer-state-change", options));
    if (this.debug) {
      console.debug("Fired offer-state-change event", options.detail);
    }
  }
  decline() {
    var _a;
    const offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");
    if ([...offers].some((el) => el.quote == void 0)) {
      return;
    }
    offers == null ? void 0 : offers.forEach((c) => {
      const item = c;
      item.selectedState = SelectedState.DECLINED;
    });
    this.selectedState = SelectedState.DECLINED;
    const options = {
      detail: [...offers].map((o) => {
        const el = o;
        return {
          quote: el.quote,
          selectedState: SelectedState[el.selectedState]
        };
      }),
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent("offer-state-change", options));
    if (this.debug) {
      console.debug("Fired offer-state-change event", options.detail);
    }
  }
  get total() {
    var _a;
    const offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");
    return [...offers].reduce((value, o) => {
      const el = o;
      return el.selectedState === SelectedState.ACCEPTED ? value + el.quote.total : value;
    }, 0);
  }
};
_PackageToggleOfferElement.styles = [
  offerBoxStyles,
  css`
      :host {
        height: 100%;
        width: 100%;
        max-width: 1024px;
        margin-top: unset;
      }

      #multi-offer-wrapper {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        container-type: inline-size;
      }

      #multi-offer-wrapper #legal-disclaimer {
        padding: 0px 4px;
      }

      #offers {
        margin-top: unset;
        display: flex;
        align-items: stretch;
        gap: var(--default-vi-package-display-spacing);
      }

      .decline-action {
        outline: 1px solid var(--default-vi-border-color);
        border-radius: var(--default-vi-border-radius);
        padding: 16px;
        background-color: var(--default-vi-bg-color);
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .decline-action offer-accordion-header h1 {
        font-size: var(--vi-multi-offer-header-font-size); 
        font-weight: bold;
        margin: 0;
      }

      section#errors {
        color: var(--default-vi-danger-color);
        font-weight: bold;
        text-align: center;
      }

      section#errors p {
        margin: 0;
      }

      payment-element {
        margin-top: 20px;
      }

      @media (max-width: 830px) {
        #offers {
          flex-direction: column;
        }
      }
    `
];
let PackageToggleOfferElement = _PackageToggleOfferElement;
__decorateClass([
  property({ attribute: "product" })
], PackageToggleOfferElement.prototype, "product");
__decorateClass([
  property({ attribute: "customer-first-name" })
], PackageToggleOfferElement.prototype, "customerFirstName");
__decorateClass([
  property({ attribute: "customer-last-name" })
], PackageToggleOfferElement.prototype, "customerLastName");
__decorateClass([
  property({ attribute: "customer-email-address" })
], PackageToggleOfferElement.prototype, "customerEmailAddress");
__decorateClass([
  property({ attribute: "customer-street-address" })
], PackageToggleOfferElement.prototype, "customerStreetAddress");
__decorateClass([
  property({ attribute: "customer-state" })
], PackageToggleOfferElement.prototype, "customerState");
__decorateClass([
  property({ attribute: "customer-city" })
], PackageToggleOfferElement.prototype, "customerCity");
__decorateClass([
  property({ attribute: "customer-postal-code" })
], PackageToggleOfferElement.prototype, "customerPostalCode");
__decorateClass([
  provide({ context: quoteContext }),
  state()
], PackageToggleOfferElement.prototype, "quoteForProductDisplay");
__decorateClass([
  state()
], PackageToggleOfferElement.prototype, "quotes");
export {
  PackageToggleOfferElement
};
